import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Send, Mail } from "lucide-react";

export default function ContactSection() {
  const [form, setForm] = useState({ nombre: "", email: "", mensaje: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.nombre || form.nombre.trim().length < 2) errs.nombre = "Escribe tu nombre";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) errs.email = "Email inválido";
    if (!form.mensaje || form.mensaje.trim().length < 5) errs.mensaje = "Escribe tu mensaje";
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Mensaje enviado. Te contactaremos pronto.");
      setForm({ nombre: "", email: "", mensaje: "" });
    } catch (err) {
      toast.error("No se pudo enviar el mensaje. Intenta de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-16 bg-[#f8f9fa]">
      <div className="bf-container grid gap-8 lg:grid-cols-2 items-start">
        <div>
          <div className="bf-chip mb-3"><Mail className="h-3.5 w-3.5" /> Contáctanos</div>
          <h2 className="font-display text-3xl sm:text-4xl text-[#333333]">
            ¿Prefieres que <span className="text-[#f05c3e]">nosotros</span> te contactemos?
          </h2>
          <p className="mt-3 text-[#666666] leading-relaxed max-w-lg">
            Déjanos tu mensaje y un asesor te responderá directamente al correo que nos indiques.
          </p>
          <div className="mt-6 space-y-2 text-sm text-[#333333]">
            <p><strong>Correo:</strong> mario@brillofinance.com</p>
            <p><strong>WhatsApp:</strong> +52 33 4406 5965</p>
            <p><strong>Web:</strong> brillofinance.com</p>
          </div>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#e5e7eb] rounded-2xl p-6" noValidate>
          <div className="grid gap-4">
            <div>
              <Label htmlFor="c-nombre">Nombre</Label>
              <Input
                id="c-nombre"
                data-testid="contact-nombre"
                value={form.nombre}
                onChange={(e) => set("nombre", e.target.value)}
                placeholder="Tu nombre"
              />
              {errors.nombre && <p className="mt-1 text-xs text-red-600">{errors.nombre}</p>}
            </div>
            <div>
              <Label htmlFor="c-email">Email</Label>
              <Input
                id="c-email"
                data-testid="contact-email"
                type="email"
                value={form.email}
                onChange={(e) => set("email", e.target.value)}
                placeholder="tu@correo.com"
              />
              {errors.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
            </div>
            <div>
              <Label htmlFor="c-mensaje">Mensaje</Label>
              <Textarea
                id="c-mensaje"
                data-testid="contact-mensaje"
                rows={5}
                value={form.mensaje}
                onChange={(e) => set("mensaje", e.target.value)}
                placeholder="Cuéntanos brevemente lo que necesitas..."
              />
              {errors.mensaje && <p className="mt-1 text-xs text-red-600">{errors.mensaje}</p>}
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="contact-submit"
              className="bf-btn-primary rounded-full px-6 py-3 inline-flex items-center justify-center gap-2 font-semibold disabled:opacity-70"
            >
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
              Enviar mensaje
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
